import { GetSheetCountDTO } from 'dtos/GetSheetCountDTO';
import { api } from 'services/api';

export const GetSheetCount = async (): Promise<GetSheetCountDTO[]> => {
  const { data } = await api.get<GetSheetCountDTO[]>('/sheets/listSheetCount');
  return data;
};
